const ACCOUNT_ROUTES = {
  activity: 'activity',
  agreements: 'agreements',
  contact: 'contact',
  membership: 'membership',
  password: 'password',
  payment: 'payment',
  program: 'program',
  sessions: 'sessions',
  settings: 'settings',
} as const;

export default ACCOUNT_ROUTES;
